<template>
  <div class="luck2021">
    <div class="luck2021__menu">
      <lpMenu :menu="menu" :imgPath="imgPath" />
    </div>
    <div class="luck2021__form">
      <lpForm
        :menu="menu"
        :csrf-token="csrfToken"
        :my-nickname="myNickname"
        :my-birthday="myBirthday"
        :subscription-flg="subscriptionFlg"
      />
    </div>
  </div>
</template>

<script>
import lpMenu from "./lpMenu";
import lpForm from "./lpForm";

export default {
  name: "Yearluck2021Lp",
  components: {
    lpMenu,
    lpForm,
  },
  data() {
    return {
      imgPath: '/static/img/yearluck/y2021/',
      elWidth: 375,
    }
  },
  props: {
    menu: {
      type: Object,
      default () {
        return {}
      }
    },
    csrfToken: {
      type: String,
      default() {
        return ''
      }
    },
    myNickname: {
      type: String,
      default() {
        return ''
      }
    },
    myBirthday: {
      type: String,
      default() {
        return ''
      }
    },
    subscriptionFlg: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style scoped lang="scss">
.luck2021 {
  padding: 0 0 60px;
  &__menu {}
  &__form {}
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2021/yearluck2021Lp.vue